module.exports = "<div class=\"content-top clearfix\">\n\t<h1 class=\"al-title\" translate>{{ activePageTitle }}</h1>\n\n\t<ul class=\"breadcrumb al-breadcrumb\" *ngIf=\"router.url !== '/pages/dashboard'\">\n\t\t<li class=\"breadcrumb-item\">\n\t  \t\t<a routerLink=\"/pages/dashboard\" translate>{{'home'}}</a>\n\t\t</li>\n\t\t<li class=\"breadcrumb-item active\" translate>{{ activePageTitle }}</li>\n\t</ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baContentTop/baContentTop.html
// module id = ../../../../../src/app/theme/components/baContentTop/baContentTop.html
// module chunks = main